export default __webpack_public_path__ + "static/media/stock6.9b876352.jpg";